import { DateTime } from 'luxon'

export const getStandardDateTime = (date?: string | undefined, timeZone = 'UTC', format?: string): string => {
  if (!date) return ''
  if (!DateTime.fromISO(date, { zone: timeZone }).isValid) return 'Invalid DateTime'

  return DateTime.fromISO(date, { zone: timeZone }).toFormat(format ? format : 'LLL dd, yyyy hh:mm a') // Feb 20, 2023 12:00 AM
}
